function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.973 8.75H14a5.25 5.25 0 00-4.584 7.817L2.929 5.437C7.654-.676 16.44-1.803 22.555 2.92a13.991 13.991 0 014.418 5.83z",
  fill: "#F44336"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 14c-.007 7.73-6.27 13.993-14 14-.585.002-1.17-.037-1.75-.117l6.3-11.258a5.263 5.263 0 00-1.925-7.174 5.201 5.201 0 00-2.613-.7h12.961A13.802 13.802 0 0128 14z",
  fill: "#FFC107"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.55 16.625l-6.3 11.258h-.011C4.573 26.915-.857 19.915.112 12.25a13.991 13.991 0 012.817-6.811l6.487 11.13.035.057a5.25 5.25 0 009.1 0z",
  fill: "#4CAF50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.55 16.625a5.25 5.25 0 01-9.1 0l-.034-.058A5.25 5.25 0 0114 8.751h.011a5.2 5.2 0 012.613.7 5.263 5.263 0 011.925 7.174z",
  fill: "#F44336"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.55 16.625a5.25 5.25 0 01-9.1 0l-.034-.058A5.25 5.25 0 0114 8.751h.011a5.2 5.2 0 012.613.7 5.263 5.263 0 011.925 7.174z",
  fill: "#2196F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.98 19.834a5.79 5.79 0 01-2.896-.777 5.833 5.833 0 012.917-10.89 5.833 5.833 0 015.056 8.75 5.866 5.866 0 01-5.076 2.917zm.031-10.5a4.653 4.653 0 00-4.058 2.333 4.67 4.67 0 106.383-1.708 4.666 4.666 0 00-2.324-.625z",
  fill: "#FAFAFA"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
}))));